/* eslint-disable */ import { assertBoolean, attributeSwitchComponent, memoEval, sceneEntityObjectRemoteMaterialOverrideComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const applianceWithPowderCoatingComponents = [
    attachComponent.withComponent(attributeSwitchComponent, 'powderCoating', true).withAlias('ApplianceWithPowderCoating').attach(memoEval((self)=>[
            self.powderCoating
        ], (powderCoating)=>({
            value: powderCoating
        })), (state)=>{
        assertBoolean(state.value);
        return {
            powderCoating: state.value
        };
    }),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'default', true).withAlias('ApplianceWithPowderCoating').attach(memoEval((self)=>[
            self.$controlPanelColor,
            self.$controlPanelMetalness,
            self.$controlPanelRoughness,
            self.$controlPanelRoughnessMapUrl,
            self.$controlPanelNormalMapUrl
        ], ($controlPanelColor, $controlPanelMetalness, $controlPanelRoughness, $controlPanelRoughnessMapUrl, $controlPanelNormalMapUrl)=>({
            fileUrl: '/models/jms.glb',
            materialName: 'controlsFrontPanelMaterial',
            materialsToOverride: [
                'controlsFrontPanelMaterial'
            ],
            color: $controlPanelColor,
            metalness: $controlPanelMetalness,
            roughness: $controlPanelRoughness,
            roughnessMapUrl: $controlPanelRoughnessMapUrl,
            normalMapUrl: $controlPanelNormalMapUrl
        })))
];

//# sourceMappingURL=appliance-with-powder-coating.js.map